import {Component, ElementRef} from '@angular/core';
import {LayoutService} from './service/app.layout.service';
import {AppMenuComponent} from './app.menu.component';

@Component({
  standalone: true,
  selector: 'app-sidebar',
  imports: [
    AppMenuComponent
  ],
  templateUrl: './app.sidebar.component.html'
})
export class AppSidebarComponent {

  constructor(public layoutService: LayoutService, public el: ElementRef) {
  }

}
